<template>
  <nav @mouseenter="isExpanded = true" @mouseleave="isExpanded = false">
    <v-app-bar clipped-left app class="elevation-0 grey lighten-4">
      <v-app-bar-nav-icon
        v-if="loggedIn"
        text
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>
        <span class="font-weight-light">RW</span>
        <span>Central</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="loggedIn" text color="grey">
        <router-link
          style="text-decoration: none; color: inherit"
          :to="{ name: 'logout' }"
        >
          <span>Wyloguj</span>
          <v-icon right>mdi-exit-to-app</v-icon>
        </router-link>
      </v-btn>
      <v-btn v-if="!loggedIn" text color="grey">
        <router-link
          style="text-decoration: none; color: inherit"
          :to="{ name: 'login' }"
        >
          <span>Zaloguj</span>
          <v-icon right>mdi-exit-to-app</v-icon>
        </router-link>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      class="grey lighten-4"
      permanent
      clipped
      v-if="loggedIn"
      app
      v-model="drawer"
      :mini-variant="!isExpanded"
    >
      <v-list nav dense>
        <template v-for="(item, index) in menuItems">
          <v-list-group
            v-if="item.children"
            :key="`group-${index}`"
            :value="false"
            :prepend-icon="item.icon"
            color="gray"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="(child, childIndex) in item.children"
              :key="`child-${index}-${childIndex}`"
              router
              :to="child.route"
              :class="{ 'pl-6': isExpanded }"
            >
              <v-list-item-icon>
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="`item-${index}`" router :to="item.route">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
export default {
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
  },
  data() {
    return {
      drawer: false,
      isExpanded: false,
      menuItems: [
        { icon: "mdi-view-dashboard", text: "Pulpit", route: "/" },
        {
          icon: "mdi-folder-outline",
          text: "Produkty",
          route: "/productsTable",
        },
        {
          icon: "mdi-format-list-checkbox",
          text: "Rezerwacje",
          route: "/reservations",
        },
        {
          icon: "mdi-clipboard-list-outline",
          text: "Oferty",
          children: [
            {
              icon: "mdi-format-list-bulleted",
              text: "Lista ofert",
              route: "/offers",
            },
            {
              icon: "mdi-format-list-group",
              text: "Grupy komponentów",
              route: "/componentgroups",
            },
          ],
        },
        {
          icon: "mdi-alert-circle-outline",
          text: "Ostrzeżenia",
          route: "/warnings",
        },
        { icon: "mdi-basket-outline", text: "Zamówienia", route: "/orders" },
        { icon: "mdi-truck-outline", text: "Przesyłki", route: "/shipments" },
        { icon: "mdi-tag", text: "Allegro", route: "/allegro" },
        { icon: "mdi-account-multiple", text: "Użytkownicy", route: "/users" },
        { icon: "mdi-cog-outline", text: "Opcje", route: "/options" },
        {
          icon: "mdi-hammer-screwdriver",
          text: "Narzędzia",
          children: [
            {
              icon: "mdi-tag-arrow-up-outline",
              text: "Akutalizacja CSV",
              route: "/csvupdate",
            },
            {
              icon: "mdi-folder-download-outline",
              text: "Generator raportów",
              route: "/wfirmareportgenerator",
            },
          ],
        },
        { icon: "mdi-forum", text: "Czat", route: "/chat" },
      ],
    };
  },
  watch: {
    drawer(val) {
      this.isExpanded = val;
    },
  },
};
</script>
